import { render, staticRenderFns } from "./IconLangTh.vue?vue&type=template&id=48ec9f49"
import script from "./IconLangTh.vue?vue&type=script&lang=js"
export * from "./IconLangTh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports